import './Images.css'; // Custom styles for Images component

import React, { useCallback, useEffect, useRef, useState } from 'react';

import Slider from 'react-slick';
import { assest } from '../../assest/assest';

// Assuming this is where your assets are stored


const Images = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 600 && window.innerWidth <= 1100);
  const sliderRef = useRef(null);

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 600);
    setIsTablet(window.innerWidth > 600 && window.innerWidth <= 1100);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  const teamMembers = [
    { image: assest.t, name: 'Tharindu Ananda', title: 'Editors- in-chief' },
    { image: assest.shehara, name: 'Shehara Rajakaruna', title: 'Editors- in-chief' },
    { image: assest.kezara, name: 'Kesara Kulathunga', title: 'Partnership Coordinator' },
    { image: assest.teki, name: 'Tekshila Peramuna', title: 'Partnership Coordinator' },
    { image: assest.lakma, name: 'Lakma Rajapaksha', title: 'Edify Coordinator' },
    { image: assest.binaru, name: 'Binaru Shakya', title: 'PR Coordinator' },
    { image: assest.samoda, name: 'Samoda Wijesooriya', title: 'PR Coordinator' },
    { image: assest.nadun, name: 'Pasidu Nadun', title: 'Creative Director' },
    { image: assest.meshel, name: 'Mishel Fernando', title: 'Editorial Management' },
    { image: assest.senudha, name: 'Senuda Jayathilaka', title: 'Editorial Management' },
    { image: assest.pavitra, name: 'Pavithra Nilupul', title: 'Interview Coordinator' },
    { image: assest.chatuni, name: 'Chathuni Nimasha', title: 'Interview Coordinator' },
    { image: assest.shashika, name: 'Shashika Prabath', title: 'Web design lead' },
    { image: assest.kau, name: 'Kaushalya Wickramasinghe', title: 'Video Editor' },
    { image: assest.pasi, name: 'Pasidu Dulanjaya', title: 'Video Editor' }
  ];

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow:5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className='xx'>
    <div className="images-section" id="images" style={{ position: 'relative', padding: '20px', color: '#fff' }}>
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${assest.bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      />
      <div
        className="dark-overlay"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
            
          zIndex: 1,
        }}
      />
      <div style={{ position: 'relative', zIndex: 2 }}>
        <h2 id='our-team' className="gallery-heading">Our Team</h2>
        <h4 className='heading-sub'>  -Thank You Team for Your Support-</h4>
        <Slider ref={sliderRef} {...settings}>
          {teamMembers.map((member, idx) => (
            <div key={idx} className="slide">
              <div className="image-wrapper">
                <img
                  src={member.image}
                  alt={member.title}
                  className="team-image"
                />
              </div>
              <h3 style={{color:'#ac834f'}} className="team-title">{member.title}</h3>
              <h4 className="team-title">{member.name}</h4>
            </div>
          ))}
        </Slider>
      </div>
    </div>
    </div>
  );
};

export default Images;
